export interface OverViewDetail {
  totalDriveCampaign: overViewDetailEnum.totalDriveCampaign;
  totalDriveCampaignOnTime: overViewDetailEnum.totalDriveCampaignOnTime;
  totalDriveCampaignDelayed: overViewDetailEnum.totalDriveCampaignDelayed;
  totalAverageDelayInDays: overViewDetailEnum.totalAverageDelayInDays;
}
export enum overViewDetailEnum {
  totalDriveCampaign = 0,
  totalDriveCampaignOnTime = 0,
  totalDriveCampaignDelayed = 0,
  totalAverageDelayInDays = 0,
}
